import TweenedNumber from 'components/tweened-number'
import type { IDisplayInputProps } from './types'
import { toNumber } from '@/utils/number'
import Icon from 'components/icon'
import { defineVariants } from '@/utils/style/variant'
import { computed, defineComponent } from 'vue'
import { FORM_INPUT_FIELD_PROPS } from '../input/types'

const useClasses = defineVariants({
  slots: {
    base: {
      class:
        'flex flex-col items-center justify-center w-full border border-gray-300 bg-gray-100 py-1 px-3'
    },
    innerWrapper: {
      class: 'flex flex-row items-center gap-1'
    }
  },
  variants: {
    hasIcon: {
      true: {
        innerWrapper: {
          class: 'grid grid-cols-[max-content_max-content] gap-2 items-center content-center align-center justify-center self-center',
          style: {
            justifyItems: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            alignContent: 'center',
            alignSelf: 'center'
          },
          options: {
            removeClasses: ['flex', 'flex-row']
          }
        }
      }
    }
  }
})

const DisplayInput = defineComponent<Omit<IDisplayInputProps, 'type' | 'schema'>>({
  setup(props, { slots }) {

    const hasIcon = computed(() => !!props.icon);
    const classes = useClasses({ hasIcon });

    return () => {
      return (
        <div class={classes.value.base.class}>
          {props.title && <div class={`text-[10px] text-gray-500 ${props.titleClass}`}>
            {props.title ? props.title : ''}
          </div> }
          <div class={[props.subtitleClass, classes.value.innerWrapper.class]} style={classes.value.innerWrapper.style}>
            {props.icon && <Icon src={props.icon} />}
            <div class="text-sm font-medium">
              {props.numberTweening ? <TweenedNumber value={toNumber(props.value)} /> : props.value}
              {slots.default ? slots.default() : ''}
            </div>
          </div>
        </div>
      )
    }
  }
});

DisplayInput.props = [...FORM_INPUT_FIELD_PROPS, 'value', 'titleClass', 'subtitleClass', 'numberTweening', 'icon', 'title']

export default DisplayInput
